import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeleteToken } from '../../../authentication/store/actions/login.actions';
import { Store } from '@ngrx/store';
import { environment } from '../../../../../environments/environment';
import { GetLinesSuccess } from '../../../lines/store/actions/lines.actions';
import { SetSelectedLine } from '../../../lines/store/actions/line.actions';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { GetMsisdnListSuccess } from '../../../lines/store/actions/msidn-list.actions';
import { GetProFleetList } from '../../store/actions/display-pro-fleet-modal.actions';
import { CustomerInterface } from '../../../account/models/customer.interface';
import { SupportUserInterface } from '../../models/support-user.interface';
import { ExtranetService } from '../../services/extranet.service';
import { LoginService } from '../../../authentication/services/login.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  standalone: false
})

export class MenuComponent implements OnInit, AfterViewInit {

  @Input()
  brand: string;

  @Input()
  customer: CustomerInterface|null;

  environment = environment;
  linesMenu: string = '';
  landLinesMenu: string = '';
  billsMenu: string = '';
  paymentsMenu: string = '';
  accountMenu: string = '';
  forumMenu: string = '';
  proFleetMenu: string = '';
  sponsorshipMenu: string = '';
  vitrineUrl: string;
  menuOpen = false;
  proFleetToken: string|null = null;
  supportUser: SupportUserInterface;

  constructor(
      private store: Store<any>,
      private router: Router,
      private extranetService: ExtranetService,
      private loginService: LoginService
  ) {}

  ngOnInit() {
    this.supportUser = this.extranetService.getSupportUser();
    this.setSelectedMenu(null);
    this.simulateClickMenuButton();
    this.vitrineUrl = environment.data.vitrineUrl;
    this.proFleetToken = null;
  }

  ngAfterViewInit() {
    setInterval(() => {
      if (!this.proFleetToken) {
        this.proFleetToken = localStorage.getItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN);
      }
    }, 300);
  }

  toggleMenu() {
    this.menuOpen ? this.menuOpen = false : this.menuOpen = true;
  }

  goTo(page: string) {
    this.setSelectedMenu(page);
    if (this.menuOpen) {
      this.simulateClickMenuButton();
    }
    if (page === 'dimelo') {
      localStorage.setItem(ConstsHelper.LOCAL_STORAGE_CALLBACK, JSON.stringify({callback: this.environment.data.assistanceUrl}));
      window.open(this.environment.data.assistanceUrl);
    } else {
      this.router.navigate(['/' + page]);
    }
  }

  public simulateClickMenuButton() {
    if (this.menuOpen) {
      const evt = document.createEvent('MouseEvents');
      const touchEvt = new Event('touchstart');
      evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      document.getElementById('buger-menu').dispatchEvent(evt);
      document.getElementById('buger-menu').dispatchEvent(touchEvt);
    }
    this.menuOpen = false;
  }

  logout() {
    this.loginService.logout().subscribe(result => {
      this.store.dispatch(new DeleteToken());
      this.store.dispatch(new GetLinesSuccess([]));
      this.store.dispatch(new SetSelectedLine(null));
      this.store.dispatch(new GetMsisdnListSuccess([]));
      this.router.navigate(['/connexion']);
      window.location.reload();
      this.simulateClickMenuButton();
    });
  }

  private setSelectedMenu(myPage: string|null) {
    this.linesMenu = '';
    this.landLinesMenu = '';
    this.billsMenu = '';
    this.paymentsMenu = '';
    this.accountMenu = '';
    this.forumMenu = '';
    this.proFleetMenu = '';
    this.sponsorshipMenu = '';

    let page = myPage;
    if (myPage == null) {
      const splitRouter = this.router.url.split('/');
      page = splitRouter[1];
      if (['compte', 'adresses'].indexOf(page) !== -1) {
        page = 'compte';
      } else if (['ligne', 'lignes'].indexOf(page) !== -1) {
        page = 'lignes';
      } else if (splitRouter.indexOf('credit_compte') !== -1) {
        page = 'paiements';
      } else if (splitRouter.indexOf('express') !== -1) {
        page = 'factures';
      } else if (splitRouter.indexOf('nouvelle_carte') !== -1) {
        page = 'compte';
      } else if (splitRouter.indexOf('fixes') !== -1) {
        page = 'fixes';
      } else if (splitRouter.indexOf('parrainage') !== -1) {
        page = 'parrainage';
      }
    }

    const activeMenu = 'active active-menu';
    switch (page) {
      case 'lignes':
        this.linesMenu = activeMenu;
        break;
      case 'factures':
        this.billsMenu = activeMenu;
        break;
      case 'paiements':
        this.paymentsMenu = activeMenu;
        break;
      case 'compte':
        this.accountMenu = activeMenu;
        break;
      case 'fixes':
        this.landLinesMenu = activeMenu;
        break;
      case 'parrainage':
        this.sponsorshipMenu = activeMenu;
        break;
    }
  }

  displayProFleetModal() {
    this.store.dispatch(new GetProFleetList(true));
  }
}
